<template>
  <div class="login-wrapper">
    <LoginForm />
  </div>
</template>

<script>
  import LoginForm from '@/components/LoginForm'
  import Header from './header'

  export default {
    name: 'Login',
    components: {
      Header,
      LoginForm
    },
    data() {
      return {
        //
      }
    },
    created() {
      console.log(this.$cookies.keys());
    }
  }
</script>

<style scoped>
.login-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>